import React, { useEffect, useState } from 'react'
import { Link } from 'react-router-dom'
import Typography from '@mui/material/Typography'
import Visibility from '@mui/icons-material/Visibility'
import { User } from '../interfaces/user'
import { viewLibertin } from '../../services/viewLibertin'
import { useTranslation } from 'react-i18next'
import Cookies from 'js-cookie'
import { handleFavoriteClick } from '../fonctions/addFavorite'
import GalleryCards from './GalleryCards'
import { MdOutlineStarOutline, MdOutlineStarPurple500 } from 'react-icons/md'
import { Libertin } from '../interfaces/libertin'

type GalleryItem = {
  id: number
  fileUrl: string
  fileName: string
  cover?: boolean
  status: number
}

type LibertinCardProps = {
  libertin: Libertin
  user: User
  statusToShow: number[]
  gallery: GalleryItem[]
}

const LibertinCard: React.FC<LibertinCardProps> = ({
  libertin,
  user,
  statusToShow,
  gallery,
}) => {
  const { t } = useTranslation()
  const [isFavorite, setIsFavorite] = useState(false)
  const [isHovered, setIsHovered] = useState(false)

  const formatURL = (title: string, id: number) => {
    return `${title
      .toLowerCase()
      .replace(/[^a-z0-9\s-]/g, '')
      .replace(/\s+/g, '-')}/${id}`
  }

  const handleClick = async (
    event: React.MouseEvent<HTMLAnchorElement, MouseEvent>,
  ) => {
    event.preventDefault()
    try {
      await viewLibertin(Number(libertin.id))
      window.location.href = `/libertin/${formatURL(
        libertin.title,
        Number(libertin.id),
      )}`
    } catch (error) {
      console.error('Error:', error)
    }
  }
  useEffect(() => {
    let favorites
    try {
      favorites = JSON.parse(Cookies.get('MyFavorites') || '{}')
    } catch (e) {
      favorites = {}
    }
    setIsFavorite(favorites[libertin.id] !== undefined)
  }, [libertin.id])

  return (
    <Link
      id='libertin-card'
      to={`/libertin/${formatURL(libertin.title, Number(libertin.id))}`}
      className='group flex border border-1 border-grisclair hover:text-white hover:shadow-xl flex-col items-left bg-grisclair transition-all hover:bg-redpink rounded-lg'
      style={{
        fontFamily: 'Poppins, sans-serif',
      }}
      onClick={handleClick}
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
    >
      <div className='overflow-hidden rounded-t-lg h-[170px] sm:h-[200px] md:h-[220px] lg:h-[250px] xl:h-[270px]'>
        <GalleryCards
          gallery={gallery}
          coverImage={gallery.find(img => img.cover)}
          gender={user.userProfile?.gender}
          statusToShow={statusToShow}
          isHovered={isHovered}
        />
      </div>

      <div className='px-2'>
        <Typography
          id='nickname'
          variant='h6'
          className='text-lg text-redpink group-hover:text-white transition-colors duration-300'
        >
          {user.nickname}
        </Typography>
        {user.address && (
          <Typography id='city' variant='body1' className='text-anthracite'>
            {user.address.city}
          </Typography>
        )}
      </div>
      <div className='w-full px-2 py-2'>
        <div className='float-left flex'>
          <Typography
            className='pr-0'
            variant='body2'
            onClick={event =>
              handleFavoriteClick(event, libertin.id, setIsFavorite)
            }
            style={{ cursor: 'pointer' }}
          >
            {isFavorite ? (
              <MdOutlineStarPurple500 className='pr-1 transition-all text-2xl text-redpink group-hover:text-white group-hover:transition-all' />
            ) : (
              <MdOutlineStarOutline className='pr-1 text-2xl' />
            )}
          </Typography>
          <Typography className='pr-2 flex items-center' variant='body2'>
            <Visibility className='pr-1' />
            <span>{libertin.views}</span>
          </Typography>
        </div>
        <div className='float-right'>
          <Typography variant='body2' className='text-right '>
            {libertin.age} {t('years-old')}
          </Typography>
        </div>
      </div>
    </Link>
  )
}

export default LibertinCard
